import AreaEditoriale from '@components/organisms/AreaEditoriale/AreaEditoriale'
import Superfici from '@components/organisms/Superfici/Superfici'
import { PaginaNode } from '@gql/graphql'
import useFindMenu from '@hooks/useFindMenu'
import useTrans from '@hooks/useTrans'
import {
  Banner,
  CollezioneHero,
  Decorations,
  FormatsColors,
  HeroStickyBar,
  HeroStickyBarMobile,
  CollezioneHead,
  Page,
  Prefooter,
  MagazineSection,
  ProgettiSection,
  CataloghiSection,
  TextMedia,
  BannerCertificazioni,
  Opuses,
} from 'components/organisms'
import styles from './CollezioneDetailTemplate.module.sass'
import useTransRoute from '@hooks/useTransRoute'
import { useEffect, useRef } from 'react'
import { collezioneToTrack, trackingEcommerceEvent } from '@utils/gtm'

interface Props {
  pagina?: PaginaNode
  collezione?: any
}

const CollezioneDetailTemplate = (props: Props) => {
  const { pagina = undefined, collezione = undefined } = props

  const t = useTrans()
  const tRoute = useTransRoute()
  const homeMenu = useFindMenu('pagina-homepage')
  const collezioneMenu = useFindMenu('pagina-prodotto-detail')
  const fullLappatoMenu = useFindMenu('full-lappato', collezioneMenu)
  const NsfMenu = useFindMenu('nsf', collezioneMenu)
  const ergonMenu = useFindMenu('ergon-banner', homeMenu)
  const bannerTypeIndex = useRef(0)
  const getNextBannerType = () => (bannerTypeIndex.current++ % 2 === 0 ? 'left' : 'right')

  const catalogoToItem = (c) => ({
    pk: c.id,
    name: c.nomeWeb,
    url: c.url,
  })

  const cataloghiItem = {
    name: t('Cataloghi'),
    children: [
      ...(collezione.catalogo?.url
        ? [
            {
              pk: 'catalogo',
              name: t('Catalogo'),
              children: [catalogoToItem(collezione.catalogo)],
            },
          ]
        : []),
      ...(collezione.cataloghiBrochure?.length
        ? [
            {
              pk: 'brochure',
              name: t('Brochure'),
              children: collezione.cataloghiBrochure.map((x) => catalogoToItem(x)),
            },
          ]
        : []),
    ],
  }

  const stickyBarOptions = [
    ...(collezione?.spessoriFormati?.length || collezione?.colori?.length
      ? [
          {
            label: t('Formati'),
            url: '#formats-colors',
          },
        ]
      : []),
    ...(collezione?.decori?.length ? [{ label: t('Decori'), url: '#decorations' }] : []),
    ...(cataloghiItem?.children?.length ? [{ label: t('Catalogo'), url: '#catalogo' }] : []),
    { label: t('Contatti'), url: tRoute('/contatti')?.href }, // TODO - check che debba andare alla pagina generica dei contatti
  ]

  useEffect(() => {
    trackingEcommerceEvent('view_item', {
      items: [collezioneToTrack(collezione)],
    })
  }, [])

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <HeroStickyBar logo={collezione.logo} options={stickyBarOptions} />
      <HeroStickyBarMobile logo={collezione.logo} options={stickyBarOptions} />
      <CollezioneHead collezione={collezione} />
      <CollezioneHero collezione={collezione} />
      <AreaEditoriale collezione={collezione} />
      {(!!collezione.description || !!collezione.video) && (
        <TextMedia
          item={{
            spaceTop: 'md',
            spaceBottom: 'none',
            image: collezione?.immagineVideo?.url,
            video: {
              provider: 'youtube',
              url: collezione.linkVideo,
              videoId: collezione.video,
              ratio: '9:16',
            },
            description: collezione.description,
          }}
          mediaPos="left"
          size="sm"
        />
      )}
      <FormatsColors refId="formats-colors" collezione={collezione} />
      <Decorations refId="decorations" collezione={collezione} />
      <Opuses opuses={collezione.opuses} />
      <Superfici collezione={collezione} />
      <CataloghiSection refId={'catalogo'} item={cataloghiItem} />
      <BannerCertificazioni
        item={{
          name: t('Certificazioni'),
          children:
            collezione.certificazioni?.map((x) => ({
              pk: x.pk,
              name: x.title,
              url: x.url,
            })) || [],
        }}
      />

      {collezione?.isUsa && (
        <Banner item={ergonMenu} theme="neutral20" type={getNextBannerType()} />
      )}
      {collezione?.lappato && collezione?.lappatoUrl && fullLappatoMenu && (
        <Banner
          item={{ ...fullLappatoMenu, url: collezione.lappatoUrl, blank: true }}
          theme="neutral20"
          type={getNextBannerType()}
        />
      )}
      {collezione?.nsf && NsfMenu && (
        <Banner
          item={{
            ...NsfMenu,
            // logo: '/public/images/logo_nsf.png',
          }}
          type={getNextBannerType()}
        />
      )}
      <ProgettiSection progetti={collezione.progetti} theme="neutral10" />
      {collezione?.categoriaEffetto && (
        <Banner
          item={{
            name: collezione.categoriaEffetto.title,
            description: collezione.categoriaEffetto.abstract,
            image: collezione.categoriaEffetto.mainImage,
            ctaLabel: t('Approfondisci'),
            url: collezione.categoriaEffetto.url,
          }}
          theme="neutral20"
          type={getNextBannerType()}
        />
      )}
      <MagazineSection magazines={collezione.magazines} theme="neutral10" />
      <Prefooter />
    </Page>
  )
}

export default CollezioneDetailTemplate
